<template>
  <v-card>
    <div>
      <v-data-table
        :headers="headers_barche"
        :items="items_barche_visualizzate"
        item-key="nome"
        class="elevation-1"
        height="75vh"
      >
        <!-- Riga dei valori filtrati -->
        <template v-slot:top>
          <v-toolbar color="indigo" dense>
            <v-toolbar-title class="white--text">
              Anagrafica Barche
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn @click="clickNuovaBarca" small v-bind="attrs" v-on="on">
                  <v-icon color="primary">mdi-plus</v-icon>
                </v-btn>
              </template>
              <span>Aggiungi Barca</span>
            </v-tooltip>

            <v-spacer></v-spacer>

            <!-- Bottone di attivazione dei filtri -->
            <v-tooltip bottom v-if="filtri_visible === false">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="mr-5"
                  @click="filtri_visible = true"
                  small
                  v-bind="attrs"
                  v-on="on"
                  ><v-icon color="purple lighten-2">mdi-filter</v-icon></v-btn
                >
              </template>
              <span>Filtri</span>
            </v-tooltip>

            <!-- Bottone di disattivazione dei filtri -->
            <v-tooltip bottom v-else>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="mr-5"
                  @click="ripristina"
                  small
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="purple lighten-2">mdi-filter-off</v-icon>
                </v-btn>
              </template>
              <span>Ripristina</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="clickAggiungiPuntoStandard"
                  small
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="purple lighten-2">mdi-map-marker-path</v-icon>
                </v-btn>
              </template>
              <span>Aggiungi Zona Manutenzione Standard</span>
            </v-tooltip>
            <v-spacer></v-spacer>
            <!-- Chiudi Anagrafica Barche -->
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn @click="goBack" small v-bind="attrs" v-on="on">
                  <v-icon color="error">mdi-keyboard-backspace</v-icon>
                </v-btn>
              </template>
              <span>Chiudi</span>
            </v-tooltip>
          </v-toolbar>
          <v-row
            align="center"
            class="my-1"
            justify="center"
            v-show="filtri_visible === true"
          >
            <!-- Filtro del nome barca -->
            <v-col>
              <v-autocomplete
                background-color="#ffffff"
                @change="filtra"
                dense
                hide-details
                :items="items_barche_totali"
                :item-text="(item) => item.des_macchina"
                :item-value="(item) => item.des_macchina"
                label="Nome Barca"
                style="display: inline-block; max-width: 350px"
                v-model="des_macchina_search"
              >
                <template v-slot:append>
                  <v-icon
                    class="ml-2"
                    @click="
                      des_macchina_search = '';
                      filtra();
                    "
                    color="primary"
                    >{{
                      des_macchina_search == ""
                        ? "mdi-filter"
                        : "mdi-filter-off"
                    }}
                  </v-icon>
                </template>
              </v-autocomplete>
            </v-col>

            <!-- Filtro della matricola -->
            <v-col>
              <v-autocomplete
                background-color="#ffffff"
                @change="filtra"
                dense
                hide-details
                :items="items_barche_totali"
                :item-text="(item) => item.modello"
                :item-value="(item) => item.modello"
                label="Modello"
                style="display: inline-block; max-width: 350px"
                v-model="modello_search"
              >
                <template v-slot:append>
                  <v-icon
                    class="ml-2"
                    @click="
                      modello_search = '';
                      filtra();
                    "
                    color="primary"
                    >{{
                      modello_search == "" ? "mdi-filter" : "mdi-filter-off"
                    }}
                  </v-icon>
                </template>
              </v-autocomplete>
            </v-col>

            <!-- Filtro della marca -->
            <v-col>
              <v-autocomplete
                background-color="#ffffff"
                @change="filtra"
                dense
                hide-details
                :items="items_barche_totali"
                :item-text="(item) => item.matricola"
                :item-value="(item) => item.matricola"
                label="Matricola"
                style="display: inline-block; max-width: 350px"
                v-model="matricola_search"
              >
                <template v-slot:append>
                  <v-icon
                    class="ml-2"
                    @click="
                      matricola_search = '';
                      filtra();
                    "
                    color="primary"
                    >{{
                      matricola_search == "" ? "mdi-filter" : "mdi-filter-off"
                    }}
                  </v-icon>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col>
              <!-- Filtro della marca -->
              <v-autocomplete
                background-color="#ffffff"
                @change="filtra"
                dense
                hide-details
                :items="items_barche_totali"
                :item-text="(item) => item.marca"
                :item-value="(item) => item.marca"
                label="Marca"
                style="display: inline-block; max-width: 350px"
                v-model="marca_search"
              >
                <template v-slot:append>
                  <v-icon
                    class="ml-2"
                    @click="
                      marca_search = '';
                      filtra();
                    "
                    color="primary"
                    >{{ marca_search == "" ? "mdi-filter" : "mdi-filter-off" }}
                  </v-icon>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col>
              <!-- Filtro della zona geografica -->
              <v-autocomplete
                background-color="#ffffff"
                @change="filtra"
                dense
                hide-details
                :items="items_barche_totali"
                :item-text="(item) => item.des_reparto"
                :item-value="(item) => item.des_reparto"
                label="Zona Geografica"
                style="display: inline-block; max-width: 350px"
                v-model="des_reparto_search"
              >
                <template v-slot:append>
                  <v-icon
                    class="ml-2"
                    @click="
                      des_reparto_search = '';
                      filtra();
                    "
                    color="primary"
                    >{{
                      des_reparto_search == "" ? "mdi-filter" : "mdi-filter-off"
                    }}
                  </v-icon>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
        </template>

        <!-- Bottone di modifica della barca -->
        <template v-slot:[`item.modifica`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="clickModificaBarca(item)"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="primary"> mdi-pencil </v-icon>
              </v-btn>
            </template>
            <span>Modifica Barca</span>
          </v-tooltip>
        </template>

        <!-- Colonna della data consegna -->
        <template v-slot:[`item.data_acquisto`]="{ item }">
          {{
            item.data_acquisto === ""
              ? ""
              : `${item.data_acquisto.substring(
                  8,
                  10
                )}/${item.data_acquisto.substring(
                  5,
                  7
                )}/${item.data_acquisto.substring(0, 4)}`
          }}
        </template>

        <!-- Colonna della dell'inizio garanzia -->
        <template v-slot:[`item.inizio_garanzia`]="{ item }">
          {{
            item.inizio_garanzia === ""
              ? ""
              : `${item.inizio_garanzia.substring(
                  8,
                  10
                )}/${item.inizio_garanzia.substring(
                  5,
                  7
                )}/${item.inizio_garanzia.substring(0, 4)}`
          }}
        </template>

        <!-- Colonna della fine garanzia -->
        <template v-slot:[`item.fine_garanzia`]="{ item }">
          {{
            item.fine_garanzia === ""
              ? ""
              : `${item.fine_garanzia.substring(
                  8,
                  10
                )}/${item.fine_garanzia.substring(
                  5,
                  7
                )}/${item.fine_garanzia.substring(0, 4)}`
          }}
        </template>

        <!-- Bottone di eliminazione della barca -->
        <template v-slot:[`item.elimina`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="clickElimina(item)" small v-bind="attrs" v-on="on">
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Elimina</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </div>

    <!-- Dialog di conferma eliminazione barca -->
    <v-dialog v-model="conferma_elimina_dialog" width="unset">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Conferma Eliminazione
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <span style="font-size: 18px">
            Confermi l'eliminazione della Barca selezionata?
          </span>
          <v-divider class="my-5"></v-divider>
          <v-container class="ma-0 pa-0">
            <v-row align="center" justify="center">
              <v-col cols="12" align="center" justify="center">
                <!-- Bottone di annullamento -->
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mr-5"
                      @click="conferma_elimina_dialog = false"
                      small
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon color="error"> mdi-close </v-icon>
                    </v-btn>
                  </template>
                  <span>Annulla</span>
                </v-tooltip>

                <!-- Bottone di conferma -->
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mr-5"
                      @click="eliminaBarca"
                      small
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon color="success"> mdi-check </v-icon>
                    </v-btn>
                  </template>
                  <span>Conferma</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di modifica della barca -->
    <v-dialog v-model="modifica_barche">
      <ModificaBarca
        :barca_sel="barca_sel"
        @chiudi_dialog="chiudiDialog"
        :des_usate="des_usate"
        :flagEM="flagEM"
        :id_filtro_nave="id_filtro_nave"
        @salvata_macchina="handleSalvataMacchina"
        :visible="modifica_barche"
      />
    </v-dialog>

    <!-- Dialog di gestione dei punti standard di DM -->
    <v-dialog v-model="dialog_punti_standard" width="600px">
      <EditZoneBarca
        @click_chiudi="handleChiudiDialogPunti"
        :visible="dialog_punti_standard"
      />
    </v-dialog>

    <!-- Overlay di caricamento -->
    <v-overlay :value="overlay" style="z-index: 10">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>

<script>
import _ from "lodash";
import EditZoneBarca from "@/components/ELECTRICALMARINE/EditZoneBarca.vue";
import ModificaBarca from "@/components/ELECTRICALMARINE/ModificaBarca.vue";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

class Barca {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] =
          arg[c.nome] != undefined
            ? c.complex === false
              ? arg[c.nome]
              : JSON.parse(JSON.stringify(arg[c.nome]))
            : c.default_val;
      });
    } else {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }

  // Metodo per resettare tutti i campi
  reset() {
    const campi = this.setCampi();

    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setCampi() {
    const campi = [
      { nome: "autonoma", default_val: 0, complex: false },
      { nome: "cod_macchina", default_val: "", complex: false },
      { nome: "costo_orario", default_val: 0, complex: false },
      { nome: "data_acquisto", default_val: "", complex: false },
      { nome: "data_consegna", default_val: "", complex: false },
      { nome: "des_connessione", default_val: "", complex: false },
      { nome: "des_macchina", default_val: "", complex: false },
      { nome: "des_reparto", default_val: "", complex: false },
      { nome: "des_stato", default_val: "", complex: false },
      { nome: "modello", default_val: "", complex: false },
      { nome: "matricola", default_val: "", complex: false },
      { nome: "id_centrocosto", default_val: null, complex: false },
      { nome: "id_funzione", default_val: null, complex: false },
      { nome: "id_macchina", default_val: -1, complex: false },
      { nome: "id_reparto", default_val: null, complex: false },
      { nome: "id_stato", default_val: null, complex: false },
      { nome: "id_tipo_get_macchina", default_val: null, complex: false },
      { nome: "id_utente", default_val: localStorage.id, complex: false },
      { nome: "inizio_garanzia", default_val: "", complex: false },
      { nome: "fine_garanzia", default_val: "", complex: false },
      { nome: "macchina_img", default_val: "", complex: false },
      { nome: "marca", default_val: "", complex: false },
      { nome: "matricola", default_val: "", complex: false },
      { nome: "modello", default_val: "", complex: false },
      { nome: "multi_commessa", default_val: 0, complex: false },
      { nome: "ore_disponibilita", default_val: 0, complex: false },
      { nome: "progetto", default_val: [new Progetto()], complex: true },
      { nome: "schedula", default_val: 0, complex: false },
      { nome: "specifiche", default_val: "", complex: false },
      { nome: "tipo_connessione", default_val: 0, complex: false },
      { nome: "validita", default_val: 1, complex: false },
    ];

    return campi;
  }
}

class Progetto {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] =
          arg[c.nome] != undefined
            ? c.complex === false
              ? arg[c.nome]
              : JSON.parse(JSON.stringify(arg[c.nome]))
            : c.default_val;
      });
    } else {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }

  // Metodo per resettare tutti i campi
  reset() {
    const campi = this.setCampi();

    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setCampi() {
    const campi = [
      { nome: "attivato", default_val: 1, complex: false },
      { nome: "codice", default_val: "", complex: false },
      { nome: "committente", default_val: null, complex: false },
      { nome: "data_inizio", default_val: "", complex: false },
      { nome: "des_progetto", default_val: "", complex: false },
      { nome: "id_progetto", default_val: -1, complex: false },
      { nome: "tipo_progetto", default_val: null, complex: false },
      { nome: "stato", default_val: null, complex: false },
      { nome: "validita", default_val: 1, complex: false },
    ];

    return campi;
  }
}

export default {
  name: "AnagraficaBarche",
  components: {
    EditZoneBarca,
    ModificaBarca,
    SnackbarQV,
  },
  props: {
    flagEM: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // Variabili d'appoggio
      barca_sel: new Barca(),
      des_macchina_search: "",
      des_reparto_search: "",
      id_filtro_nave: null,
      marca_search: "",
      matricola_search: "",
      modello_search: "",

      // Modal
      conferma_elimina_dialog: false,
      dialog_punti_standard: false,
      filtri_visible: false,
      modifica_barche: false,
      overlay: true,

      // Array
      des_usate: new Array(),
      items_barche_totali: [],
      items_barche_visualizzate: [],
      headers_barche: [
        {
          text: "Modifica",
          value: "modifica",
          sortable: false,
        },
        {
          text: "Nome Barca",
          value: "des_macchina",
          sortable: false,
        },
        {
          text: "Modello e Num. Scafo",
          value: "modello",
          sortable: false,
        },
        {
          text: "Matricola HIN",
          value: "matricola",
          sortable: false,
        },
        {
          text: "Marca",
          value: "marca",
          sortable: false,
        },
        {
          text: "Zona Geografica",
          value: "des_reparto",
          sortable: false,
        },
        {
          text: "Inizio Garanzia C.",
          value: "inizio_garanzia",
          sortable: false,
        },
        {
          text: "Fine Garanzia C.",
          value: "fine_garanzia",
          sortable: false,
        },
        {
          text: "Fine Garanzia Ns.",
          value: "data_acquisto",
          sortable: false,
        },
        {
          text: "Eliminazione",
          value: "elimina",
          sortable: false,
        },
      ],
    };
  },
  computed: {},
  watch: {},
  methods: {
    chiudiDialog() {
      this.modifica_barche = false;
      this.barca_sel = new Barca();
    },
    clickAggiungiPuntoStandard() {
      this.dialog_punti_standard = true;
    },
    clickModificaBarca(item) {
      this.barca_sel = new Barca(item);

      /* Se questa barca non ha un progetto, glie
       * ne aggiungo uno nuovo in modo da poterlo
       * salvare dopo. */
      if (this.barca_sel.progetto.length == 0) {
        this.barca_sel.progetto.push(new Progetto());
      }

      this.modifica_barche = true;
    },
    clickElimina(item) {
      this.barca_sel = new Barca(item);
      this.conferma_elimina_dialog = true;
    },
    clickNuovaBarca() {
      this.barca_sel = new Barca();
      this.modifica_barche = true;
    },
    eliminaBarca() {
      this.conferma_elimina_dialog = false;
      this.barca_sel.validita = 0;

      // Faccio la query di salvataggio
      const dataarray = [];
      dataarray.push(Object.assign({}, this.barca_sel));
      const request = {
        controller: "Manutenzione",
        method: "PUT",
        richiesta: {
          action: "updatemacchina",
          token: localStorage.getItem("user_token"),
          tabella: dataarray,
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        if (res.status === 200) {
          // Aggiorno il componente dopo l'eliminazione.
          this.getMacchine();

          /* Se updatemacchina è andato in 200 faccio un updatenavi
           * per aggiornare le zone di default sulle varie barche. */
          let updatenavi = {
            controller: "Manutenzione",
            method: "POST",
            richiesta: {
              action: "updatenavi",
              token: localStorage.getItem("user_token"),
            },
          };

          this.$store
            .dispatch("api", updatenavi)
            .then((res2) => {
              if (res2.status === 200) {
                /* Se anche updatenavi è andato in 200 faccio un updatetabellabarche
                 * per aggiornare le zone di default sulla barca eliminata. */
                let updatetabellabarche = {
                  controller: "Manutenzione",
                  method: "PUT",
                  richiesta: {
                    action: "updatetabellabarche",
                    token: localStorage.getItem("user_token"),
                    id_macchina: this.barca_sel.id_macchina,
                    causale: "delete",
                  },
                };
                this.$store
                  .dispatch("api", updatetabellabarche)
                  .then((res3) => {
                    if (res3.status === 200) {
                      /* Se la chiamata BE è andata a buon fine
                       * stampo una snackbar di conferma. */
                      this.$refs.SnackbarQV.print(
                        "success",
                        `La procedura di eliminazione è stata completata correttamente.`
                      );
                    } else {
                      this.$refs.SnackbarQV.print(
                        "orange",
                        `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
                      );
                    }
                  })
                  .catch(() => {
                    // Se ricevo un errore avviso l'Utente con una snackbar.
                    this.$refs.SnackbarQV.print(
                      "error",
                      `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
                    );
                  });
              } else {
                // Se ricevo un errore avviso l'Utente con una snackbar.
                this.$refs.SnackbarQV.print(
                  "error",
                  `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
                );
              }
            })
            .catch(() => {
              this.$refs.SnackbarQV.print(
                "error",
                `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
              );
            });
        } else {
          this.$refs.SnackbarQV.print(
            "orange",
            `Criticità tecnica con codice ${res.status}, non è stato possibile salvare i dati.`
          );
        }
      });
    },
    filtra() {
      let items_barche_tmp = [];
      this.items_barche_totali.forEach((elem) => {
        items_barche_tmp.push(elem);
      });
      // Filtro il nome della barca
      if (this.des_macchina_search != "") {
        // Faccio un array temporaneo
        const res = [];
        /* Filtro gli elementi visualizzati dopo i passaggi precedenti
         * e li inserisco in "res". */
        items_barche_tmp.forEach((elem) => {
          if (elem.des_macchina == this.des_macchina_search) {
            res.push(elem);
          }
        });
        // Modello la risposta provvisoria su "res".
        items_barche_tmp = res;
      }

      // Filtro il modello della barca
      if (this.modello_search != "") {
        // Faccio un array temporaneo
        const res = [];
        /* Filtro gli elementi visualizzati dopo i passaggi precedenti
         * e li inserisco in "res". */
        items_barche_tmp.forEach((elem) => {
          if (elem.modello == this.modello_search) {
            res.push(elem);
          }
        });
        // Modello la risposta provvisoria su "res".
        items_barche_tmp = res;
      }

      // Filtro la matricola della barca
      if (this.matricola_search != "") {
        // Faccio un array temporaneo
        const res = [];
        /* Filtro gli elementi visualizzati dopo i passaggi precedenti
         * e li inserisco in "res". */
        items_barche_tmp.forEach((elem) => {
          if (elem.matricola == this.matricola_search) {
            res.push(elem);
          }
        });
        // Modello la risposta provvisoria su "res".
        items_barche_tmp = res;
      }

      // Filtro la marca della barca
      if (this.marca_search != "") {
        // Faccio un array temporaneo
        const res = [];
        /* Filtro gli elementi visualizzati dopo i passaggi precedenti
         * e li inserisco in "res". */
        items_barche_tmp.forEach((elem) => {
          if (elem.marca == this.marca_search) {
            res.push(elem);
          }
        });
        // Modello la risposta provvisoria su "res".
        items_barche_tmp = res;
      }

      // Filtro la zona geografica della barca
      if (this.des_reparto_search != "") {
        // Faccio un array temporaneo
        const res = [];
        /* Filtro gli elementi visualizzati dopo i passaggi precedenti
         * e li inserisco in "res". */
        items_barche_tmp.forEach((elem) => {
          if (elem.des_reparto == this.des_reparto_search) {
            res.push(elem);
          }
        });
        // Modello la risposta provvisoria su "res".
        items_barche_tmp = res;
      }

      this.items_barche_visualizzate = [];
      this.items_barche_visualizzate = items_barche_tmp;
    },
    goBack() {
      this.$emit("click_indietro");
    },
    getMacchine() {
      /* Faccio una gettabelle per ricevere l'id dell'etichetta
       * che mi serve per identificare le macchine che sono navi. */
      let gettabelle = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "gettabelle",
          token: localStorage.getItem("user_token"),
          tipo: "TIPO_GET_MACCHINA",
          filter: "validita = 1",
        },
      };

      this.$store.dispatch("api", gettabelle).then((res) => {
        if (res.status === 200) {
          // Valorizzo l'id_filtro nave per riconoscere le macchine che sono navi
          res.data.forEach((e) => {
            if (e.cod === "NAVE") {
              this.id_filtro_nave = e.id_tabella;
            }
          });

          // Faccio una chiamata per avere tutte le macchine
          const getlistamacchine = {
            controller: "Manutenzione",
            method: "POST",
            richiesta: {
              action: "getlistamacchine",
              token: localStorage.getItem("user_token"),
            },
          };

          this.overlay = true;
          this.$store
            .dispatch("api", getlistamacchine)
            .then((res) => {
              this.overlay = false;
              if (res.status === 200) {
                // Resetto gli array di supporto.
                this.items_barche_totali = new Array();
                this.items_barche_visualizzate = new Array();

                // Per ogni macchina, se la riconosco come barca la aggiungo al mio array.
                res.data.macchine.forEach((e) => {
                  /* Mi metto da parte tutte le des di macchine già
                   * esistenti per non doppiarle se creo una nuova barca. */
                  this.des_usate = new Array();
                  this.des_usate.push(e.des_macchina);

                  if (
                    this.id_filtro_nave != null &&
                    e.id_tipo_get_macchina === this.id_filtro_nave
                  ) {
                    const macchina = new Barca(e);

                    this.items_barche_totali.push(Object.assign({}, macchina));
                  }
                });

                // Pareggio le barche visualizzate e le barche totali.
                this.items_barche_visualizzate = Array.from(
                  this.items_barche_totali
                );
              } else {
                this.$refs.SnackbarQV.print(
                  "orange",
                  `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
                );
              }
            })
            .catch((err) => {
              this.overlay = false;
              console.error(err);
              this.$refs.SnackbarQV.print(
                "orange",
                `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
              );
            });
        } else {
          this.$refs.SnackbarQV.print(
            "orange",
            `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
          );
        }
      });
    },
    handleChiudiDialogPunti() {
      this.dialog_punti_standard = false;
    },
    handleSalvataMacchina() {
      this.modifica_barche = false;
      this.barca_sel = new Barca();
      this.getMacchine();
    },
    ripristina() {
      // Rendo invisibili i filtri e resetto le chiavi di filtro
      this.des_macchina_search = "";
      this.des_reparto_search = "";
      this.marca_search = "";
      this.matricola_search = "";
      this.modello_search = "";
      this.filtri_visible = false;

      // Resetto le commesse visualizzati in tabella
      this.items_barche_visualizzate = [];
      this.items_barche_visualizzate = _.cloneDeep(this.items_barche_totali);
    },
  },
  created() {},
  mounted() {
    this.getMacchine();
  },
};
</script>
<style scoped>
.block-with-text {
  overflow: hidden;
  position: relative;
  font-size: 12px;
  line-height: 12px;
  max-height: 48px;
  text-align: justify;
  margin-right: -1em;
  padding-right: 1em;
}
.block-with-text:before {
  content: "...";
  position: absolute;
  right: 0;
  bottom: 0;
}
.block-with-text:after {
  content: "";
  position: absolute;
  right: 0;
  width: 1em;
  height: 1em;
  margin-top: 0.2em;
  background: white;
}
</style>